import PolicyPage, { PolicySection } from "../../components/policy/PolicyPage";

function PoliticaDatos() {
    return (
        <PolicyPage title="Política de Privacidad de Datos">
            <PolicySection title="1. Responsable del Tratamiento">
                <p><strong>emmpieza</strong> es responsable del tratamiento de sus datos personales.</p>
                <p>Contacto:</p>
                <ul>
                    <li>Email: <a href="mailto:emmpieza@gmail.com">emmpieza@gmail.com</a></li>
                    <li>WhatsApp: <a href="https://wa.me/573118569675">+57 311 856 9675</a></li>
                </ul>
            </PolicySection>

            <PolicySection title="2. Datos Personales que Tratamos">
                <p>Tratamos los siguientes tipos de datos personales:</p>
                <ul>
                    <li><strong>Datos de identificación:</strong> Nombre, apellidos</li>
                    <li><strong>Datos de contacto:</strong> Correo electrónico, número de teléfono, WhatsApp</li>
                    <li><strong>Datos de navegación:</strong> Dirección IP, cookies, datos de uso del sitio web</li>
                    <li><strong>Datos de proyecto:</strong> Información sobre proyectos, ideas y requerimientos</li>
                    <li><strong>Datos de comunicación:</strong> Historial de conversaciones en el chat</li>
                </ul>
            </PolicySection>

            <PolicySection title="3. Finalidad del Tratamiento">
                <p>Tratamos sus datos personales para las siguientes finalidades:</p>
                <ul>
                    <li>Gestionar y responder a sus consultas y solicitudes</li>
                    <li>Proporcionar cotizaciones y servicios de desarrollo</li>
                    <li>Mantener comunicación comercial y de soporte</li>
                    <li>Cumplir con obligaciones legales y contractuales</li>
                    <li>Mejorar nuestros servicios y experiencia del usuario</li>
                    <li>Enviar comunicaciones comerciales (con su consentimiento)</li>
                </ul>
            </PolicySection>

            <PolicySection title="4. Base Legal">
                <p>El tratamiento de sus datos personales se basa en:</p>
                <ul>
                    <li><strong>Consentimiento:</strong> Cuando nos proporciona sus datos voluntariamente</li>
                    <li><strong>Ejecución de contrato:</strong> Para la prestación de servicios solicitados</li>
                    <li><strong>Interés legítimo:</strong> Para mejorar nuestros servicios y comunicación</li>
                    <li><strong>Obligación legal:</strong> Para cumplir con requisitos legales aplicables</li>
                </ul>
            </PolicySection>

            <PolicySection title="5. Conservación de Datos">
                <p>
                    Conservaremos sus datos personales durante el tiempo necesario para cumplir con las
                    finalidades para las que fueron recopilados, y en cualquier caso:
                </p>
                <ul>
                    <li>Mientras mantenga una relación comercial con nosotros</li>
                    <li>Durante los plazos establecidos por la legislación aplicable</li>
                    <li>Hasta que solicite su eliminación, siempre que no exista obligación legal de conservación</li>
                </ul>
            </PolicySection>

            <PolicySection title="6. Transferencias Internacionales">
                <p>
                    Sus datos personales pueden ser almacenados y procesados en servidores ubicados
                    fuera de Colombia. En estos casos, garantizamos que se aplican medidas de seguridad
                    adecuadas y que se cumplen los estándares de protección de datos aplicables.
                </p>
            </PolicySection>

            <PolicySection title="7. Sus Derechos">
                <p>De acuerdo con la legislación de protección de datos, usted tiene derecho a:</p>
                <ul>
                    <li><strong>Acceso:</strong> Obtener información sobre sus datos personales que tratamos</li>
                    <li><strong>Rectificación:</strong> Corregir datos inexactos o incompletos</li>
                    <li><strong>Supresión:</strong> Solicitar la eliminación de sus datos cuando ya no sean necesarios</li>
                    <li><strong>Oposición:</strong> Oponerse al tratamiento de sus datos en ciertas circunstancias</li>
                    <li><strong>Limitación:</strong> Solicitar la limitación del tratamiento de sus datos</li>
                    <li><strong>Portabilidad:</strong> Recibir sus datos en formato estructurado</li>
                    <li><strong>Revocación del consentimiento:</strong> Retirar su consentimiento en cualquier momento</li>
                </ul>
                <p>
                    Para ejercer estos derechos, puede contactarnos en{" "}
                    <a href="mailto:emmpieza@gmail.com">emmpieza@gmail.com</a>
                </p>
            </PolicySection>

            <PolicySection title="8. Seguridad de los Datos">
                <p>Implementamos medidas técnicas y organizativas apropiadas para proteger sus datos personales contra:</p>
                <ul>
                    <li>Acceso no autorizado</li>
                    <li>Pérdida o destrucción accidental</li>
                    <li>Alteración o divulgación no autorizada</li>
                </ul>
            </PolicySection>

            <PolicySection title="9. Cookies y Tecnologías de Seguimiento">
                <p>
                    Nuestro sitio web utiliza cookies y tecnologías similares. Para más información,
                    consulte nuestra Política de Privacidad general.
                </p>
            </PolicySection>

            <PolicySection title="10. Menores de Edad">
                <p>
                    Nuestros servicios no están dirigidos a menores de 18 años. No recopilamos
                    intencionalmente datos personales de menores sin el consentimiento de sus padres o
                    tutores legales.
                </p>
            </PolicySection>

            <PolicySection title="11. Cambios en esta Política">
                <p>
                    Podemos actualizar esta política de privacidad de datos ocasionalmente. Le
                    notificaremos sobre cambios significativos mediante la publicación de la política
                    actualizada en nuestro sitio web.
                </p>
            </PolicySection>

            <PolicySection title="12. Autoridad de Control">
                <p>
                    Si considera que el tratamiento de sus datos personales no cumple con la normativa
                    aplicable, tiene derecho a presentar una reclamación ante la autoridad de protección
                    de datos competente.
                </p>
            </PolicySection>
        </PolicyPage>
    );
}

export default PoliticaDatos;
